export enum EditFieldTypeEnum {
    Invoice,
    Good
}

export enum EditFieldsEnum {
    // Goods fields
    PreviousWarehouseLineNumber = 'PreviousWarehouseLineNumber',
    DirectShipmentDate = 'DirectShipmentDate',
    ClassificationNumber = 'ClassificationNumber',
    Description = 'Description',
    Quantity = 'Quantity',
    UnitOfMeasure = 'UnitOfMeasure',
    ValueCurrencyConversion = 'ValueCurrencyConversion',
    CurrencyCode = 'CurrencyCode',
    CountryOfOrigin = 'CountryOfOrigin',
    PlaceOfExport = 'PlaceOfExport',
    PstHstQst = 'PstHstQst',
    DestinationProvince = 'DestinationProvince',
    TariffTreatment = 'TariffTreatment',
    TariffCode = 'TariffCode',
    ValueDutyCode = 'ValueDutyCode',
    RulingNumber = 'RulingNumber',
    OrderInCouncil = 'OrderInCouncil',
    DutyReliefLicence = 'DutyReliefLicence',
    SpecialAuthorityPermit = 'SpecialAuthorityPermit',
    CustomsDuty = 'CustomsDuty',
    ExciseDuty = 'ExciseDuty',
    TimeLimitType = 'TimeLimitType',
    TimeLimitFrom = 'TimeLimitFrom',
    TimeLimitTo = 'TimeLimitTo',
    ExciseTaxCode = 'ExciseTaxCode',
    ExciseTaxAmount = 'ExciseTaxAmount',
    ProvAlcoholTaxAmount = 'ProvAlcoholTaxAmount',
    AlcoholPercent = 'AlcoholPercent',
    ProvTabaccoTaxAmount = 'ProvTabaccoTaxAmount',
    ProvCannabisTaxAmount = 'ProvCannabisTaxAmount',
    GSTCode = 'GSTCode',
    GSTAmount = 'GSTAmount',
    // Invoice fields
    InvoiceNumber = 'InvoiceNumber',
    PurchaseOrderNumber = 'PurchaseOrderNumber',
    InvoiceValue = 'InvoiceValue',
    USPortOfExit = 'USPortOfExit',
    PurchaserName = 'PurchaserName',
    PurchaserPOBox = 'PurchaserPOBox',
    PurchaserAddressLine1 = 'PurchaserAddressLine1',
    PurchaserAddressLine2 = 'PurchaserAddressLine2',
    PurchaserCity = 'PurchaserCity',
    PurchaserCountry = 'PurchaserCountry',
    PurchaserProvince = 'PurchaserProvince',
    PurchaserPostalCode = 'PurchaserPostalCode',
    PurchaserTelephone = 'PurchaserTelephone',
    VendorName = 'VendorName',
    VendorPOBox = 'VendorPOBox',
    VendorAddressLine1 = 'VendorAddressLine1',
    VendorAddressLine2 = 'VendorAddressLine2',
    VendorCity = 'VendorCity',
    VendorCountry = 'VendorCountry',
    VendorProvince = 'VendorProvince',
    VendorPostalCode = 'VendorPostalCode',
    VendorTelephone = 'VendorTelephone',
    // General details
    ModeOfTransport = 'ModeOfTransport',
    ReleaseDate = 'ReleaseDate',
    PreviousTransactionNumber = 'PreviousTransactionNumber',
    PortOfUnladingRegion = 'PortOfUnladingRegion',
    PortOfUnlading = 'PortOfUnlading',
    CarrierCode = 'CarrierCode',
    CargoControl = 'CargoControl',
    GrossWeight = 'GrossWeight',
    FreightCharges = 'FreightCharges',
    WarehouseNumberComingIn = 'WarehouseNumberComingIn',
    WarehouseNumberComingOut = 'WarehouseNumberComingOut',
    PreviousTransactionNumberWarehouse = 'PreviousTransactionNumberWarehouse'
}
